import { useEffect } from "react";
import { Modal, ModalBody } from 'reactstrap';
import FuneralSurvey from '../FuneralSurvey/FuneralSurvey';
import surveyTriggers from '../../../../utils/hocs/surveyTriggers';
import { isWindows } from "../../../../utils/isWindows";
import { isFirefox } from "../../../../utils/isFirefox";
import { isMacOS } from "../../../../utils/isMacOS";
import { useTheme } from '../../../../context/ThemeContext';
import closeSurveyDark from '../../../../assets/Survey/CloseSurveyDark.svg';
import "./SurveyModal.css";

function BackdropBlocker({ modalSelector = ".surveyModal .modal-content" }) {
  useEffect(() => {
    const allowInside = (t) => !!t.closest?.(modalSelector);

    const onTouchMove = (e) => { if (!allowInside(e.target)) e.preventDefault(); };
    const onWheel     = (e) => { if (!allowInside(e.target)) e.preventDefault(); };

    // passive:false is required so preventDefault() works on iOS
    document.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("wheel", onWheel);
    };
  }, [modalSelector]);

  return null;
}

const SurveyModal = (props) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const { visible, close } = surveyTriggers({
    disabled: props.surveyComplete,
    mode: "both",
  });

  return (
    <>
      {/* Mount the blocker only while the modal is open */}
      {visible && <BackdropBlocker modalSelector=".surveyModal .modal-content" />}

      <Modal
        isOpen={visible}
        toggle={()=> {}}
        className={`surveyModal ${isWindows() ? "surveyModal--windows" : ""} ${props.className || ""}`}  // ensure the class is present
        backdrop   // keep Reactstrap backdrop
      >
        <div className="d-flex align-items-center text-center justify-content-center">
          <div
            className="surveyModalCross d-flex align-items-center justify-content-center cPointer d-mdxl-none"
            onClick={(e) => { e.preventDefault(); close(); }}
          >
            {/* SVGs */}
            <svg className="icon default-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 7.27757L1.52852 11.749C1.36122 11.9163 1.14829 12 0.889734 12C0.631179 12 0.418251 11.9163 0.25095 11.749C0.0836498 11.5817 0 11.3688 0 11.1103C0 10.8517 0.0836498 10.6388 0.25095 10.4715L4.72243 6L0.25095 1.52852C0.0836498 1.36122 0 1.14829 0 0.889734C0 0.631179 0.0836498 0.418251 0.25095 0.25095C0.418251 0.0836498 0.631179 0 0.889734 0C1.14829 0 1.36122 0.0836498 1.52852 0.25095L6 4.72243L10.4715 0.25095C10.6388 0.0836498 10.8517 0 11.1103 0C11.3688 0 11.5817 0.0836498 11.749 0.25095C11.9163 0.418251 12 0.631179 12 0.889734C12 1.14829 11.9163 1.36122 11.749 1.52852L7.27757 6L11.749 10.4715C11.9163 10.6388 12 10.8517 12 11.1103C12 11.3688 11.9163 11.5817 11.749 11.749C11.5817 11.9163 11.3688 12 11.1103 12C10.8517 12 10.6388 11.9163 10.4715 11.749L6 7.27757Z" fill="#474747"/></svg>
            <svg className="icon hover-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 9.70342L2.03802 15.6654C1.81496 15.8885 1.53105 16 1.18631 16C0.841571 16 0.557667 15.8885 0.3346 15.6654C0.111533 15.4423 0 15.1584 0 14.8137C0 14.4689 0.111533 14.185 0.3346 13.962L6.29658 8L0.3346 2.03802C0.111533 1.81496 0 1.53105 0 1.18631C0 0.841571 0.111533 0.557667 0.3346 0.3346C0.557667 0.111533 0.841571 0 1.18631 0C1.53105 0 1.81496 0.111533 2.03802 0.3346L8 6.29658L13.962 0.3346C14.185 0.111533 14.4689 0 14.8137 0C15.1584 0 15.4423 0.111533 15.6654 0.3346C15.8885 0.557667 16 0.841571 16 1.18631C16 1.53105 15.8885 1.81496 15.6654 2.03802L9.70342 8L15.6654 13.962C15.8885 14.185 16 14.4689 16 14.8137C16 15.1584 15.8885 15.4423 15.6654 15.6654C15.4423 15.8885 15.1584 16 14.8137 16C14.4689 16 14.185 15.8885 13.962 15.6654L8 9.70342Z" fill="#474747"/></svg>
          </div>
        </div>

        <div className="desktopCross d-none d-mdxl-inline-flex" onClick={(e) => { e.preventDefault(); close(); }}>
            <div className="svgContainer">
              {isDark ? (
                <img src={closeSurveyDark} className="icon default-icon" alt="" />
              ) : (
                <svg className="icon default-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 7.27757L1.52852 11.749C1.36122 11.9163 1.14829 12 0.889734 12C0.631179 12 0.418251 11.9163 0.25095 11.749C0.0836498 11.5817 0 11.3688 0 11.1103C0 10.8517 0.0836498 10.6388 0.25095 10.4715L4.72243 6L0.25095 1.52852C0.0836498 1.36122 0 1.14829 0 0.889734C0 0.631179 0.0836498 0.418251 0.25095 0.25095C0.418251 0.0836498 0.631179 0 0.889734 0C1.14829 0 1.36122 0.0836498 1.52852 0.25095L6 4.72243L10.4715 0.25095C10.6388 0.0836498 10.8517 0 11.1103 0C11.3688 0 11.5817 0.0836498 11.749 0.25095C11.9163 0.418251 12 0.631179 12 0.889734C12 1.14829 11.9163 1.36122 11.749 1.52852L7.27757 6L11.749 10.4715C11.9163 10.6388 12 10.8517 12 11.1103C12 11.3688 11.9163 11.5817 11.749 11.749C11.5817 11.9163 11.3688 12 11.1103 12C10.8517 12 10.6388 11.9163 10.4715 11.749L6 7.27757Z" fill="#474747"/></svg>
              )}
              <svg className="icon hover-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 9.70342L2.03802 15.6654C1.81496 15.8885 1.53105 16 1.18631 16C0.841571 16 0.557667 15.8885 0.3346 15.6654C0.111533 15.4423 0 15.1584 0 14.8137C0 14.4689 0.111533 14.185 0.3346 13.962L6.29658 8L0.3346 2.03802C0.111533 1.81496 0 1.53105 0 1.18631C0 0.841571 0.111533 0.557667 0.3346 0.3346C0.557667 0.111533 0.841571 0 1.18631 0C1.53105 0 1.81496 0.111533 2.03802 0.3346L8 6.29658L13.962 0.3346C14.185 0.111533 14.4689 0 14.8137 0C15.1584 0 15.4423 0.111533 15.6654 0.3346C15.8885 0.557667 16 0.841571 16 1.18631C16 1.53105 15.8885 1.81496 15.6654 2.03802L9.70342 8L15.6654 13.962C15.8885 14.185 16 14.4689 16 14.8137C16 15.1584 15.8885 15.4423 15.6654 15.6654C15.4423 15.8885 15.1584 16 14.8137 16C14.4689 16 14.185 15.8885 13.962 15.6654L8 9.70342Z" fill="#474747"/></svg>
            </div>

            <span className={[isWindows() && "firefoxTop", isMacOS() && isFirefox() && "macFirefox", isMacOS() && !isFirefox() && "macClose"].filter(Boolean).join(" ")}>Close</span>

        </div>

        <ModalBody>
          <FuneralSurvey {...props} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default SurveyModal;
